import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Spinner from 'spin.js';
import './spinner.scss';

@Component({
  template: `
<div class="spinner-container">
  <div ref="spin"></div>
</div>
`
})
export class SpinnerComponent extends Vue {
  mounted() {
    const spinner = new Spinner({
      top: '12px',
      color: '#e01f32',
      speed: 1.2,
      width: 3,
      lines: 11,
      scale: 0.65
    }).spin(<any>this.$refs['spin']);
  }
}

Vue.component('spinner', SpinnerComponent);



// WEBPACK FOOTER //
// ./src/components/spinner/spinner.ts